import { render } from "./LiftMap.vue?vue&type=template&id=0f5cb704&scoped=true"
import script from "./LiftMap.vue?vue&type=script&lang=js"
export * from "./LiftMap.vue?vue&type=script&lang=js"

import "./LiftMap.vue?vue&type=style&index=0&id=0f5cb704&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f5cb704"]])

export default __exports__